/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CookiesAliases {
  FETCH_COOKIES = 'fetch-cookies',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  PANEL_0 = 'panel-0',
}
export { CookiesAliases };
